module.exports = __webpack_public_path__ + "img/shouyezuoce-en.0eaf5503.jpg";